<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para-s"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events<br/>portrayed in this novel are either products of the author’s imagination or<br/>are used fictitiously.</p>
<p class="para"> </p>
<p class="center-para-s"><span class="smallcaps">DELILAH</span>. Copyright © 2009 by India Edghill. All rights reserved.<br/>Printed in the United States of America. For information, address<br/>St. Martin’s Press,<br/>175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="center-para-s"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="para"> </p>
<p class="center-para-s">Map by Jackie Aher</p>
<p class="para"> </p>
<p class="center-para-s">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="para1">Edghill, India.</p>
<p class="indent-para1">Delilah / India Edghill.—1st ed.</p>
<p class="indent-para1">        p. cm.</p>
<p class="indent-para1">ISBN 978-0-312-33891-6</p>
<p class="indent-para2">  1. Delilah (Biblical figure)—Fiction. 2. Samson (Biblical judge)—Fiction. 3. Bible. O.T.—History of Biblical events—Fiction. I. Title.</p>
<p class="indent-para1">PS3555.D474D45 2009</p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:85%" valign="top"><p class="indent-para1">813’.54—dc22</p></td>
<td style="width:15%" valign="top"><p class="para1a">2009024138</p></td>
</tr>
</tbody></table>
<p class="para"> </p>
<p class="center-para-s">First Edition: December 2009</p>
<p class="para"> </p>
<p class="center-para-s">10    9    8    7    6    5    4    3    2    1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2fe9e891